// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/message_calculation.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import type { Date } from "../google/type/date_pb";
import { file_google_type_date } from "../google/type/date_pb";
import type { MessageListItem } from "./message_pb";
import { file_v1_message } from "./message_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/message_calculation.proto.
 */
export const file_v1_message_calculation: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_api_annotations, file_google_type_date, file_v1_message]);

/**
 * @generated from message v1.CreateOrUpdateMessageRequest
 */
export type CreateOrUpdateMessageRequest = Message<"v1.CreateOrUpdateMessageRequest"> & {
  /**
   * @generated from field: optional int32 id = 1;
   */
  id?: number;

  /**
   * Date for calculating lottery results
   *
   * @generated from field: google.type.Date calculate_date = 2;
   */
  calculateDate?: Date;

  /**
   * @generated from field: int32 customer_id = 3;
   */
  customerId: number;

  /**
   * @generated from field: string region = 4;
   */
  region: string;

  /**
   * @generated from field: string message = 5;
   */
  message: string;

  /**
   * If true, do not auto-detect region
   *
   * @generated from field: bool disable_region_detection = 6;
   */
  disableRegionDetection: boolean;

  /**
   * Groups every parse attempt of one message until it parses. App: client UUID;
   * Telegram: derived by the server. Empty or malformed values are stored as NULL.
   *
   * @generated from field: optional string attempt_group_id = 7;
   */
  attemptGroupId?: string;
};

/**
 * Describes the message v1.CreateOrUpdateMessageRequest.
 * Use `create(CreateOrUpdateMessageRequestSchema)` to create a new message.
 */
export const CreateOrUpdateMessageRequestSchema: GenMessage<CreateOrUpdateMessageRequest> = /*@__PURE__*/
  messageDesc(file_v1_message_calculation, 0);

/**
 * @generated from message v1.CreateOrUpdateMessageResponse
 */
export type CreateOrUpdateMessageResponse = Message<"v1.CreateOrUpdateMessageResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: v1.MessageListItem message = 2;
   */
  message?: MessageListItem;

  /**
   * @generated from field: repeated string warnings = 3;
   */
  warnings: string[];

  /**
   * @generated from field: repeated string errors = 4;
   */
  errors: string[];

  /**
   * @generated from field: string error_patterns = 5;
   */
  errorPatterns: string;
};

/**
 * Describes the message v1.CreateOrUpdateMessageResponse.
 * Use `create(CreateOrUpdateMessageResponseSchema)` to create a new message.
 */
export const CreateOrUpdateMessageResponseSchema: GenMessage<CreateOrUpdateMessageResponse> = /*@__PURE__*/
  messageDesc(file_v1_message_calculation, 1);

/**
 * @generated from message v1.CalculateMessageV2Request
 */
export type CalculateMessageV2Request = Message<"v1.CalculateMessageV2Request"> & {
  /**
   * @generated from field: optional int32 id = 1;
   */
  id?: number;

  /**
   * Date for calculating lottery results
   *
   * @generated from field: google.type.Date calculate_date = 2;
   */
  calculateDate?: Date;

  /**
   * @generated from field: int32 customer_id = 3;
   */
  customerId: number;

  /**
   * @generated from field: string region = 4;
   */
  region: string;

  /**
   * @generated from field: string message = 5;
   */
  message: string;

  /**
   * If true, do not auto-detect region
   *
   * @generated from field: bool disable_region_detection = 6;
   */
  disableRegionDetection: boolean;

  /**
   * Groups every parse attempt of one message until it parses. App: client UUID;
   * Telegram: derived by the server. Empty or malformed values are stored as NULL.
   *
   * @generated from field: optional string attempt_group_id = 7;
   */
  attemptGroupId?: string;
};

/**
 * Describes the message v1.CalculateMessageV2Request.
 * Use `create(CalculateMessageV2RequestSchema)` to create a new message.
 */
export const CalculateMessageV2RequestSchema: GenMessage<CalculateMessageV2Request> = /*@__PURE__*/
  messageDesc(file_v1_message_calculation, 2);

/**
 * @generated from message v1.CalculateMessageV2Response
 */
export type CalculateMessageV2Response = Message<"v1.CalculateMessageV2Response"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: repeated v1.ParseError errors = 2;
   */
  errors: ParseError[];

  /**
   * @generated from field: string normalized_message = 3;
   */
  normalizedMessage: string;

  /**
   * @generated from field: repeated v1.Token tokens = 4;
   */
  tokens: Token[];

  /**
   * @generated from field: repeated v1.Bet bets = 5;
   */
  bets: Bet[];

  /**
   * @generated from field: double two_digits_amount = 6;
   */
  twoDigitsAmount: number;

  /**
   * @generated from field: double three_digits_amount = 7;
   */
  threeDigitsAmount: number;

  /**
   * @generated from field: double four_digits_amount = 8;
   */
  fourDigitsAmount: number;

  /**
   * @generated from field: double head_tail_amount = 9;
   */
  headTailAmount: number;

  /**
   * @generated from field: double special_amount = 10;
   */
  specialAmount: number;

  /**
   * @generated from field: double cross_combo_amount = 11;
   */
  crossComboAmount: number;

  /**
   * @generated from field: double straight_combo_amount = 12;
   */
  straightComboAmount: number;

  /**
   * Region detection result (when cross-region markers or stations detected)
   *
   * @generated from field: optional v1.RegionDetectionResult region_detection = 13;
   */
  regionDetection?: RegionDetectionResult;
};

/**
 * Describes the message v1.CalculateMessageV2Response.
 * Use `create(CalculateMessageV2ResponseSchema)` to create a new message.
 */
export const CalculateMessageV2ResponseSchema: GenMessage<CalculateMessageV2Response> = /*@__PURE__*/
  messageDesc(file_v1_message_calculation, 3);

/**
 * @generated from message v1.ParseError
 */
export type ParseError = Message<"v1.ParseError"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: int32 column = 3;
   */
  column: number;

  /**
   * @generated from field: int32 end_column = 4;
   */
  endColumn: number;

  /**
   * @generated from field: string stage = 5;
   */
  stage: string;
};

/**
 * Describes the message v1.ParseError.
 * Use `create(ParseErrorSchema)` to create a new message.
 */
export const ParseErrorSchema: GenMessage<ParseError> = /*@__PURE__*/
  messageDesc(file_v1_message_calculation, 4);

/**
 * @generated from message v1.Token
 */
export type Token = Message<"v1.Token"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;

  /**
   * @generated from field: int32 position = 3;
   */
  position: number;

  /**
   * @generated from field: int32 end_pos = 4;
   */
  endPos: number;

  /**
   * @generated from field: bool is_ambiguous = 5;
   */
  isAmbiguous: boolean;

  /**
   * @generated from field: string warning = 6;
   */
  warning: string;
};

/**
 * Describes the message v1.Token.
 * Use `create(TokenSchema)` to create a new message.
 */
export const TokenSchema: GenMessage<Token> = /*@__PURE__*/
  messageDesc(file_v1_message_calculation, 5);

/**
 * @generated from message v1.Bet
 */
export type Bet = Message<"v1.Bet"> & {
  /**
   * @generated from field: string number = 1;
   */
  number: string;

  /**
   * @generated from field: int32 bet_type_id = 2;
   */
  betTypeId: number;

  /**
   * @generated from field: int32 bet_category_id = 3;
   */
  betCategoryId: number;

  /**
   * @generated from field: double unit_bet_amount = 4;
   */
  unitBetAmount: number;

  /**
   * @generated from field: repeated string stations = 5;
   */
  stations: string[];

  /**
   * @generated from field: double total_bet_amount = 6;
   */
  totalBetAmount: number;

  /**
   * @generated from field: int32 permutation_count = 7;
   */
  permutationCount: number;

  /**
   * @generated from field: int32 station_count = 8;
   */
  stationCount: number;

  /**
   * @generated from field: string original_pattern = 9;
   */
  originalPattern: string;

  /**
   * @generated from field: int32 column = 10;
   */
  column: number;

  /**
   * @generated from field: int32 end_column = 11;
   */
  endColumn: number;

  /**
   * @generated from field: string warning = 12;
   */
  warning: string;

  /**
   * @generated from field: string bet_type_code = 13;
   */
  betTypeCode: string;

  /**
   * @generated from field: string bet_type_name = 14;
   */
  betTypeName: string;
};

/**
 * Describes the message v1.Bet.
 * Use `create(BetSchema)` to create a new message.
 */
export const BetSchema: GenMessage<Bet> = /*@__PURE__*/
  messageDesc(file_v1_message_calculation, 6);

/**
 * RegionDetectionResult contains information about automatic region detection
 * When user types cross-region markers (mb, mn, mt) or station names from other regions,
 * the parser automatically detects and switches to the correct region before tokenization.
 *
 * @generated from message v1.RegionDetectionResult
 */
export type RegionDetectionResult = Message<"v1.RegionDetectionResult"> & {
  /**
   * Region before detection (e.g., "mn")
   *
   * @generated from field: string original_region = 1;
   */
  originalRegion: string;

  /**
   * Region detected from message (e.g., "mt")
   *
   * @generated from field: string detected_region = 2;
   */
  detectedRegion: string;

  /**
   * True if region was automatically changed
   *
   * @generated from field: bool region_changed = 3;
   */
  regionChanged: boolean;

  /**
   * "location_marker" or "station_match"
   *
   * @generated from field: string detection_source = 4;
   */
  detectionSource: string;

  /**
   * Vietnamese warning message to display to user
   *
   * @generated from field: string warning_message = 5;
   */
  warningMessage: string;

  /**
   * Station names that triggered detection (for station_match)
   *
   * @generated from field: string matched_stations = 6;
   */
  matchedStations: string;
};

/**
 * Describes the message v1.RegionDetectionResult.
 * Use `create(RegionDetectionResultSchema)` to create a new message.
 */
export const RegionDetectionResultSchema: GenMessage<RegionDetectionResult> = /*@__PURE__*/
  messageDesc(file_v1_message_calculation, 7);

/**
 * @generated from service v1.MessageCalculationService
 */
export const MessageCalculationService: GenService<{
  /**
   * @generated from rpc v1.MessageCalculationService.CreateOrUpdateMessage
   */
  createOrUpdateMessage: {
    methodKind: "unary";
    input: typeof CreateOrUpdateMessageRequestSchema;
    output: typeof CreateOrUpdateMessageResponseSchema;
  },
  /**
   * @generated from rpc v1.MessageCalculationService.CalculateMessageV2
   */
  calculateMessageV2: {
    methodKind: "unary";
    input: typeof CalculateMessageV2RequestSchema;
    output: typeof CalculateMessageV2ResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_message_calculation, 0);

